export default {"src":"/_next/static/media/IconHonda.a8a7505d.svg","height":24,"width":36,"blurWidth":0,"blurHeight":0};